import React, { useRef, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material';
import { PHARMACY_HALO_COLORS } from '@/config/colors';
import PharmacyHaloButton from '@/components/inputs/Button';

const PingAppTeamModal = ({ open, onClose, onConfirm, appName }) => {
  const noButtonRef = useRef(null);

  useEffect(() => {
    if (open && noButtonRef.current) {
      // Delay focus to allow the dialog to fully render
      setTimeout(() => {
        noButtonRef.current?.focus();
      }, 0);
    }
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="ping-app-team-dialog-title"
      aria-describedby="ping-app-team-dialog-description"
      maxWidth="sm"
      fullWidth={false}
      disableRestoreFocus
      PaperProps={{
        sx: {
          px: 4,
          py: 3,
          borderRadius: 4,
          textAlign: 'center',
          width: '100%',
          maxWidth: 420,
        },
      }}
    >
      <DialogTitle
        id="ping-app-team-dialog-title"
        sx={{
          color: PHARMACY_HALO_COLORS.BLUE,
          fontWeight: 'bold',
          textAlign: 'center',
          pb: 1,
        }}
      >
        Request Onboarding Support
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="ping-app-team-dialog-description"
          sx={{ textAlign: 'center', lineHeight: 1.6 }}
        >
          By pressing Yes a request will be sent to the Pharmacy Halo team to help onboard this chemist for {appName}.
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: 'center',
          gap: 2,
          pt: 2,
        }}
      >
        <button
          ref={noButtonRef}
          onClick={onClose}
          className="px-5 py-2 font-semibold rounded-lg shadow-md transition duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2"
          style={{
            backgroundColor: PHARMACY_HALO_COLORS.RED,
            color: 'white',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#4c0b04'; // Darker Red
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = PHARMACY_HALO_COLORS.RED;
          }}
        >
          No
        </button>
        <PharmacyHaloButton onClick={onConfirm}>
          Yes
        </PharmacyHaloButton>
      </DialogActions>
    </Dialog>
  );
};

export default PingAppTeamModal;

